import { put, select } from 'redux-saga/effects';
import BookingActions from './BookingRedux';
import ScheduleActions from './ScheduleRedux';
import { BOOKING_STAGE, TIME_FRAME_TITLES } from '@services/minte';
import { AuthSelectors } from './AuthRedux';

export function* confirmRecurringStartDate(action) {
  const { availableDates } = action;
  const state = yield select();

  yield put(ScheduleActions.setRecurringAvailableDates(availableDates));

  const { selectedItems } = state.schedule;

  const blockedItem = selectedItems.find(item => {
    const { serviceDate } = item;
    const { momentDate: serviceMomentDate } = serviceDate;
    const foundDate = availableDates.find(({ momentDate }) => {
      return serviceMomentDate.isSame(momentDate, 'day');
    });

    if (foundDate) {
      return true;
    }

    return false;
  });

  if (blockedItem) {
    const { row, col } = blockedItem;
    const week = +row + 1;
    const day = +col + 1;
    yield put(ScheduleActions.setRecurringRescheduleInfo({ week, day }));
    yield put(BookingActions.setBookingStep(BOOKING_STAGE.ADJUST));
  } else {
    yield put(BookingActions.setBookingStep(BOOKING_STAGE.CONFIRM));
  }
}

export function* initRecurringBookingFromSubscription(action) {
  const { activeSubscription } = action;
  const { cycle, currentCycleStartDate, propertyID } = activeSubscription;

  const properties = yield select(AuthSelectors.selectUserProperties);
  const property = properties.find(item => item.propertyID === propertyID);

  const scheduledItems = cycle.map(item => {
    const { day, week, additionalService, timeframe, ...rest } = item;
    return {
      row: `${week - 1}`,
      col: `${day - 1}`,
      ...rest,
      timeframeTitle: TIME_FRAME_TITLES[timeframe],
      addons: additionalService ? additionalService : undefined
    };
  });

  yield put(BookingActions.setBookingProperty(property));
  yield put(ScheduleActions.setScheduleItems(scheduledItems));
  yield put(ScheduleActions.setRecurringStartDate(currentCycleStartDate));
}
